import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

export const requestNoPagination = (filters) =>
  axios.post(`${apiUrl}daily-reports/list`, {
    criteria: filters
  });

export const test = () => {};



// WEBPACK FOOTER //
// ./src/actions/reports/requests.js